import React, { useEffect, useRef, useState } from "react";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import EventIcon from "@mui/icons-material/Event";

import {
  Box,
  Button,
  Divider,
  Fab,
  Grid,
  InputAdornment,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import {
  getAccountReachageDetails,
  getAllEmployeeList,
  getAlleducatio,
} from "./appoinmentDashboardApi";
import SmbAccountReachargeCard from "./AppoinmentDashboardCard";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

import { getData } from "./smbAccountRechargeCustomApiHandler";

import {
  convertDateToCustomFormat,
  getFirstDateOfMonth,
  getStartOfMonth,
} from "../../utils/commonUtils";
import AppoinmentDashboardCard from "./AppoinmentDashboardCard";
import { DatePicker } from "@mui/x-date-pickers";
import DatePickerComponent from "../../common/curstomDatePicker";
import FormModal from "./FormModal";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";
import { TextFieldSearch } from "../../common/fieldText";
import PoprchModal from "../payment/popSearch";
import CardPayment from "../payment/cardPayment";
import FormModalT from "./FormDatatt";

export default function EmployeeDetail({ gridSize }) {
  // const [data, setData] = useState();
  const [open, setOpen] = useState(false);

  const [search, setSearchvalue] = useState("");
  const [searchModal, setSearchModal] = useState(false);

  const datePickerRef = useRef();
  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  const [date, setDate] = useState(getStartOfMonth());

  const [SelectedStartDate, setSelectedStartDate] = useState(
    getFirstDateOfMonth()
  );
  const [modalData, setModalData] = useState(null);
  const [value, setValue] = React.useState("Unassigned");
  const [data, setData] = useState();
  const [valuet, setValuet] = React.useState("Assigned");
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  const cardKet = {
    educationalDetail: [
      {
        key: "employeeId",
        color: "#bb4a9b",
        label: "Employee Id",
      },
      {
        key: "employeeName",
        color: "#bb4a9b",
        label: "Employee Name",
      },

      {
        color: "#bb4a9b",
        key: "courseName",
        label: "Course Name",
      },
      // {
      //   key: "courseDetails",
      //   label: "Component Name",
      // },
      {
        key: "durationInYear",
        label: "Duration In Year",
      },
      {
        key: "courseDetails",
        label: "Course Details",
      },

      {
        key: "percentage",
        label: "Percentage",
      },

      {
        key: "grade",
        label: "Grade",
      },
      {
        key: "university",
        label: "University",
      },
      {
        key: "institute",
        label: "Institute",
      },
    ],

    incentrive: [
      {
        key: "employeeId",
        label: "Employee Id",
      },

      {
        key: "incentiveName",
        label: "Incentive Name",
      },
      {
        key: "incentiveName",
        label: "Incentive Name",
      },
      {
        key: "minimumValue",
        label: "Minimum Value",
      },
      {
        key: "maximumValue",
        label: "Maximum Value",
      },

      {
        key: "percentage",
        label: "percentage",
      },
    ],
    Deductions: [
      {
        key: "componentName",
        label: "Component Name",
      },
      {
        key: "amount",
        label: "Amount",
      },

      {
        key: "percentage",
        label: "Percentage",
      },
    ],
  };
  const handleChange = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };
  const handleChanget = (event, newValue) => {
    // setPageNo(1);

    setValuet(newValue);
  };

  useEffect(() => {
    getAllEmployeeList((res) => {
      setData(res?.list);
    });
    // getData(getAccountReachageDetails, setData);
  }, []);
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = React.useState(false);
  const [cardValue, setCardValue] = useState(null);
  const [list, setList] = useState([]);
  useEffect(() => {
    if (search) {
      getAlleducatio(
        {
          // employeeId:search?.id
        },
        (data) => {
          console.log("list  data?.data?.data ", data);

          setList(data?.data?.data?.list);
        }
      );
    }
  }, [search, cardValue]);
  useEffect(() => {
    getAlleducatio(
      {
        // employeeId:search?.id
      },
      (data) => {
        console.log("list  data?.data?.data ", data);

        setList(data?.data?.data?.list);
      }
    );
  }, []);
  const handleOpenDatePicker = () => {
    setIsDatePickerOpen(true);
  };

  const handleCloseDatePicker = () => {
    setIsDatePickerOpen(false);
  };
  useEffect(() => {}, [modalData]);
  useEffect(() => {
    if (open == false) {
      // setModalData({});
    }
  }, [open]);

  useEffect(() => {
    console.log("list list== ", list);
  }, [list]);

  return (
    <>
      <Box
        px={2}
        pb={4}
        container="true"
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              borderRadius: "5px",
              color: "#01008B",
              textAlign: "left",
              marginBottom: "20px",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              fontSize={{ xs: "12px", sm: "13px", md: "18px" }}
            >
              Employee Educational Details
            </Typography>
          </Grid>
          <Grid container alignItems="center" spacing={{ xs: 2, sm: 2 }}>
            <Grid item xs={12} sm={7} md={8} lg={9}>
              <TextField
                value={search?.name || ""}
                placeholder="Search"
                size="small"
                fullWidth
                variant="outlined"
                onClick={() => setSearchModal(true)}
                sx={{
                  width: "100%",
                  backgroundColor: "white",
                  borderRadius: "6px",
                  // color: "#555555",
                  "& .MuiOutlinedInput-root": {
                    border: "none",
                    "& fieldset": {
                      border: "none",
                    },
                    "&:hover fieldset": {
                      border: "none",
                    },
                    "&.Mui-focused fieldset": {
                      border: "none",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#555555",
                    opacity: 6,
                    fontWeight: 500,
                    cursor: "pointer",
                  },
                }}
                InputProps={{
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      {search?.name ? (
                        <CloseIcon
                          sx={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSearchvalue("");
                            setCardValue(null);
                          }}
                        />
                      ) : (
                        <SearchIcon
                          color="primary"
                          sx={{ cursor: "pointer" }}
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />

              <PoprchModal
                cardValue={cardValue}
                setCardValue={(data) => {
                  setSearchvalue(data);
                  setCardValue(data);
                }}
                callback={() => {}}
                searchModal={searchModal}
                setSearchModal={setSearchModal}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={3} sx={{ padding: "0px" }}>
              {!gridSize && (
                <Button
                  fullWidth
                  onClick={() => setOpen(true)}
                  sx={{
                    textTransform: "capitalize",
                    width: { xs: "100%", sm: "auto" },
                    whiteSpace: "nowrap",
                    zIndex: "0",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                  size="medium"
                  color="primary"
                  variant="contained"
                  aria-label="add"
                >
                  Add Educational Details
                  <AddIcon sx={{ marginLeft: "6px" }} />
                </Button>
              )}
            </Grid>
          </Grid>

          <Grid
            container
            sx={{
              p: { xs: "1px", sm: "10px" },
              mt: 2,
              background: "white",
              borderRadius: "12px",
              overflowX: "auto",
            }}
          >
            {/* Header */}
            <Grid item xs={12}>
              <Grid
                container
                sx={{
                  borderBottom: "1.5px solid black",
                  padding: "10px",
                }}
              >
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Employee ID
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Employee Name
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Course Name
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Institute
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                height: "60vh",
                overflowY: "auto",
                marginTop: "10px",
                padding: "15px",
              }}
            >
              {list.map((ele, index) => {
                if (search && search?.name !== ele?.employeeName) return null;

                return (
                  <Grid
                    container
                    key={index}
                    onClick={() => {
                      setModalData(ele);
                      setOpen(true);
                    }}
                    sx={{
                      p: "8px 0",
                      borderBottom: "1px solid #eee",
                      alignItems: "center",
                      backgroundColor: "#E8E8FF",
                      borderRadius: "8px",
                      mb: 1,
                      cursor: "pointer",
                    }}
                  >
                    <Grid
                      item
                      xs={3}
                      sx={{ pl: { xs: 2, sm: 4, md: 6, lg: 11 } }}
                    >
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontWeight: "500",
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "15px",
                          },
                        }}
                      >
                        {ele?.employeeId || "-"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={3}
                      sx={{ pl: { xs: 2, sm: 3, md: 5, lg: 10 } }}
                    >
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontWeight: "500",
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "15px",
                          },
                        }}
                      >
                        {ele?.employeeName || "-"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={3}
                      sx={{ pl: { xs: 2, sm: 4, md: 6, lg: 12 } }}
                    >
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontWeight: "500",
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "15px",
                          },
                        }}
                      >
                        {ele?.courseName || "-"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={3}
                      sx={{ pl: { xs: 3, sm: 6, md: 9, lg: 15 } }}
                    >
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontWeight: "500",
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "15px",
                          },
                        }}
                      >
                        {ele?.institute || "-"}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>

          {/* <Grid container spacing={2}>
            {list.map((ele, index) => {
              if (search != "" && search?.id != ele?.employeeId) {
                return null;
              }
              return (
                <Grid item lg={4}>
                  <CardPayment
                    item={ele}
                    setOpen={(data) => {
                      // if (value == "SalaryComponents") {
                      //   setOpen(data);
                      // }
                      // if (value == "incentrive") {
                      //   setOpent(data);
                      // }
                      // if (value == "Deductions") {
                      //   setopenDeduction(true);
                      // }
                    }}
                    setModalData={(data) => {
                      setModalData(data);
                      setOpen(true);

                      // // setFormda({...formda,id:data.id,});

                      // setFormda({
                      //   ...formda,
                      //   id: data.id,
                      //   employeeId: data?.employeeId,
                      //   componentName: data?.componentName,
                      //   amount: data?.amount,
                      //   percentage: data?.percentage,
                      // });
                      // setFormdat({
                      //   ...formdat,
                      //   id: data.id,
                      //   employeeId: data?.employeeId,
                      //   incentiveName: data?.incentiveName,
                      //   amount: data?.amount,
                      //   percentage: data?.percentage,
                      //   minimumValue: data?.minimumValue,
                      //   maximumValue: data?.maximumValue,
                      // });
                      // setFormdatTDence({
                      //   employeeId: data?.employeeId,
                      //   componentName: data?.componentName,
                      //   amount: data?.amount,
                      //   percentage: data?.percentage,
                      // });
                    }}
                    cardKet={cardKet?.educationalDetail}
                  />
                </Grid>
              );
            })}
          </Grid> */}
          <FormModalT
            open={open}
            setOpen={setOpen}
            getAll={() => {
              // if(search){
              getAlleducatio(
                {
                  // employeeId:search?.id
                },
                (data) => {
                  setList(data?.data?.data?.list);
                },
              );
              // }
            }}
            modalData={modalData}
            setModalData={setModalData}
          />
        </Grid>
      </Box>
    </>
  );
}
